import { useEffect, useState } from 'react';

import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

import AdvancedRecordTable from '../../components/Tables/advancedRecord/AdvancedRecordTable';
import RealtimeSubscriptionModal from '../../components/realtime/RealtimeSubscriptionModal';

import { useRealtime } from '../../hooks/realtime/useRealtime';

import { realtimeUserColumns } from '../../features/realtime/realtimeUserColumns';
import { getRealtimeSubscriptionFilters } from '../../features/realtime/realtimeSubscriptionFilters';
import { useRole } from '../../hooks/useRole';

const RealtimeSubscriptionsPage = () => {
  const {
    users,
    paginator,
    pageSize,
    selectedUser,

    updatePageSize,

    handlerGetUsers,
    handlerGetUserSubscriptions,
    handlerUpdateUserSubscriptions,
  } = useRealtime();

  const { dropdownOptions, fetchRolesDropdown } = useRole();

  const [filters, setFilters] = useState<any>({});

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    handlerGetUsers(0, pageSize);
    fetchRolesDropdown();
  }, []);

  const handleEditUser = async (userId: number) => {
    await handlerGetUserSubscriptions(userId);

    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleSaveSubscriptions = async (channels: any[]) => {
    if (!selectedUser) {
      return;
    }

    const payload = {
      channels: channels.map((channel) => ({
        channelId: channel.channelId,
        enabled: channel.subscribed,
      })),
    };

    await handlerUpdateUserSubscriptions(selectedUser.userId, payload);

    setModalOpen(false);

    handlerGetUsers(
      paginator?.number ?? 0,
      pageSize,
      filters.search,
      filters.role
    );
  };

  const handleFilterChange = (newFilters: any) => {
    setFilters(newFilters);

    handlerGetUsers(0, pageSize, newFilters.search, newFilters.role);
  };

  const handlePageChange = (page: number) => {
    handlerGetUsers(page, pageSize, filters.search, filters.role);
  };

  const handlePageSizeChange = (size: number) => {
    updatePageSize(size);

    handlerGetUsers(0, size, filters.search, filters.role);
  };

  const getActions = (row: any) => [
    {
      key: 'edit',
      label: 'Configurar Canales',
      onClick: () => handleEditUser(row.userId),
    },
  ];

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <AdvancedRecordTable
        columns={realtimeUserColumns}
        data={users}
        paginator={paginator}
        pageSize={pageSize}
        getActions={getActions}
        filtersConfig={getRealtimeSubscriptionFilters(dropdownOptions ?? [])}
        onFilterChange={handleFilterChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        noDataMessage="No hay usuarios registrados."
      />

      <RealtimeSubscriptionModal
        open={modalOpen}
        user={selectedUser}
        onClose={handleCloseModal}
        onSave={handleSaveSubscriptions}
      />
    </DefaultLayout>
  );
};

export default RealtimeSubscriptionsPage;
